module.exports = __webpack_public_path__ + "static/media/MaskGroup.c2cbe1c8.png";